import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TextService {
  labels = {
    general: {
      title: "Razek Pi Web",
      notFound: "Desculpe, não encontramos o que você está procurando. Que tal voltar e tentar novamente?",
      notFoundTitle: "Ops! Não encotramos essa página",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
      backToHome: "Voltar para a página inicial",
      dashboard: "Painel",
      error: "Ocorreu um erro!",
      success: "Sucesso!",
      backToLogin: "Voltar para login",
      resetPassword: "Por favor, insira seu endereço de e-mail associado à sua conta abaixo. Enviaremos um link de redefinição de senha para você recuperar o acesso à sua conta.",
      resetPasswordEmail: "Se você não receber o e-mail dentro de alguns minutos, verifique sua pasta de spam ou tente novamente mais tarde."
    },

    auth: {
      error: {
        invalidEmail: "Email inválido",
        invalidPassword: "<PASSWORD>",
        userNotFound: "Usuário não encontrado",
        userAlreadyExists: "Usuário já existe",
        invalidToken: "Token inválido",
        invalidRefreshToken: "Token de atualização inválido",
        invalidPasswordConfirmation: "As senhas não coincidem",
        invalidPasswordResetToken: "Token de redefinição de senha inválido",
        invalidPasswordResetTokenExpired:
          "Token de redefinição de senha expirado",
        invalidNewPassword: "<PASSWORD>",
        invalidCurrentPassword: "<PASSWORD>",
        invalidUsername: "Nome de usuário inválido",
        invalidUsernameOrPassword: "Nome de usuário ou senha inválido",
        invalidEmailOrPassword: "Email ou senha inválido",
        invalidEmailConfirmation: "Os emails não conferem",
        invalidNewEmail: "Novo email inválido",
        invalidCurrentEmail: "Email atual inválido",
        invalidNewUsername: "Novo nome de usuário inválido",
        invalidCurrentUsername: "Nome de usuário atual inválido",
        invalidNewPasswordConfirmation: "Nova confirmação",
      },

      success: {
        login: "Login realizado com sucesso!",
        logout: "Logout realizado com sucesso!",
        register: "Cadastro realizado com sucesso!",
      },
    },
  };
}
